import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Bar, Doughnut } from 'react-chartjs-2'
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Typography, Box, IconButton, Tooltip, useMediaQuery, styled, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom'
import { makeStyles } from '@mui/styles';

import { CustomLoadingOverlay } from '../../components'
import { coreFunctions } from '../../utils'
import { graphActions, addTitleLegoCurrent } from '../../store/actions'
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    barGraph: {
        height: '40vh',
        width: '40vw',
        [theme.breakpoints.only('xs')]: {
            width: '90vw',
            height: '38vh',
        },
        [theme.breakpoints.only('sm')]: {
            height: '40vh',
            width: '40vw',
        },
        [theme.breakpoints.only('md')]: {
            height: '40vh',
            width: '40vw',
        },
        [theme.breakpoints.only('lg')]: {
            height: '40vh',
            width: '40vw',
        },
        [theme.breakpoints.only('xl')]: {
            height: '40vh',
            width: '40vw',
        },
    },
    doughnutGraph: {
        height: '37vh',
        width: '37vw',
        [theme.breakpoints.only('xs')]: {
            width: '90vw',
            height: '35vh',
        },
        [theme.breakpoints.only('sm')]: {
            height: '37vh',
            width: '37vw',
        },
        [theme.breakpoints.only('md')]: {
            height: '37vh',
            width: '37vw',
        },
        [theme.breakpoints.only('lg')]: {
            height: '37vh',
            width: '37vw',
        },
        [theme.breakpoints.only('xl')]: {
            height: '37vh',
            width: '37vw',
        },
    },
    barGraphSection: {
        marginTop: theme.spacing(1)
    },
    DoughnutGraphSection: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.secondary.light}`
    },
    plusButton: {
        position: 'fixed',
        bottom: '3rem',
        right: '25vw',
        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
        backgroundColor: theme.palette.primary.btnLogin,
        '&:focus': {
            outline: 'none !important',
        },
        "&:hover": {
            backgroundColor: theme.palette.primary.btnLogin,
        },
        [theme.breakpoints.only('xs')]: {
            bottom: '2rem',
            right: '2vw',
        }
    }
}));

const OutletWrapperContent = styled(Box)(({ theme }) => ({
    background: "#FFFFFF",
    margin: "0px",
    marginBottom: '0px',
    minHeight: "calc(100vh - 110px)",
    overflowY: 'auto !important',
    height: '90vh',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
    alignItems: 'center',
}));

export default function DashboardComponent(props) {
    const navigate = useNavigate()
    const matches = useMediaQuery('(max-width:650px)');
    const theme = useTheme()
    const localStyles = useStyles()
    const dispatch = useDispatch()

    const [loadView, setLoadView] = useState(false)
    const [data, setData] = useState({})
    const [doughnutData, setDoughnutData] = useState({})
    const [totalDoughnutData, setTotalDoughnutData] = useState(0)
    const [doughnutName, setDoughnutName] = useState('')
    const [plugins, setPlugins] = useState([])
    const [activeData, setActiveData] = useState(false)
    const { t } = useTranslation();

    const auth = useSelector(state => state.Authentication)
    const graph = useSelector(state => state.GraphData)
    Chart.register(ChartDataLabels); // plugin to add Labels 

    useEffect(() => {
        dispatch(addTitleLegoCurrent("Dashboard"))
        dispatch(graphActions.GetGraphsData())
    }, [])


    useEffect(() => {
        console.log('all grapg data', graph.items)
        setLoadView(graph.loading)

        //! BAR GRAPH
        if (graph.items != undefined && graph.itemsMapproved != undefined) {
            setData(
                {
                    labels: graph.itemsMonthLabels, // Months 
                    datasets: [
                        graph.itemsMapproved,
                        graph.itemsMrejected,
                        graph.itemsMonHold
                    ]
                }
            )
            setActiveData(true)
        }

        //! DOUGHNUT GRAPH
        if (graph.items != undefined && graph.itemsDoughnutLabels != undefined) {
            setDoughnutData(
                {
                    labels: graph.itemsDoughnutLabels, // Months 
                    datasets: [
                        graph.itemsDoughnutData
                    ]
                }
            )
            setTotalDoughnutData(
                graph.itemsDoughnutData.data.reduce((a, b) => {
                    return a + b
                })
            )
            setDoughnutName(graph.items[1].Name)
        }
    }, [graph])


    useEffect(() => {
        if (doughnutName != '') {
            setPlugins([...plugins, {
                beforeDraw: function (chart) {
                    let width = chart.width,
                        height = chart.height,
                        ctx = chart.ctx;
                    ctx.restore();
                    let fontSize = (height / 250).toFixed(2);
                    ctx.font = fontSize + "em sans-serif";
                    ctx.textBaseline = "middle";
                    //  ctx.textAlign = 'center';
                    // console.log("Name value : ", doughnutName)
                    let text = doughnutName,
                        textX = Math.round((width - ctx.measureText(text).width) / 2),
                        textY = height / 2.6;
                    ctx.fillText(text, textX, textY);
                    ctx.save();
                }
            },
            {
                beforeDraw: function (chart) {
                    let width = chart.width,
                        height = chart.height,
                        ctx = chart.ctx;
                    ctx.restore();
                    let fontSize = (height / 250).toFixed(2);
                    ctx.font = fontSize + "em sans-serif";
                    ctx.textBaseline = "middle";
                    //  ctx.textAlign = 'center';
                    let text2 = `${totalDoughnutData}`,
                        textX = Math.round((width - ctx.measureText(text2).width) / 2),
                        textY = height / 2.2;
                    ctx.fillText(text2, textX, textY);
                    ctx.save();
                }
            }
            ])
        }
    }, [doughnutName])

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                display: true,
                color: 'black',
                anchor: 'end', // at the end of the bar
                align: 'top', // where after the anchor 
                // offset: this is the space between the anchor and the label default 4 with align
            },
            legend: {
                display: false, //Hide top Legend,
            },
        },
        scales: {
            x: {
                grid: {
                    display: false, // remove vertical grids 
                    drawBorder: false, // remove border grid
                    scaleLineColor: 'transparent', // remove border grid
                }
                //   ticks:{
                //     color: 'red', // If I wish to change bottom labels color
                //   }
            },
            y: {
                ticks: {
                    stepSize: 100  // set ticks with 100 steps
                }
            },
        },
    }

    //!DOUGHNUT GRAPH 
    const opts = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '70%',
        elements: {
            arc: {
                borderWidth: 0,
                // borderRadius: {
                //     innerEnd: 30,
                //     innerStart: 0,
                //     outerEnd: 30,
                //     outerStart: 0,
                // }
            },
        },
        plugins: {
            datalabels: {
                display: true,
                color: 'black',
            },
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'rectRounded',
                    padding: matches ? 20 : 30,
                }

            },
        },
    }

    const sendToSearch = () => {
        navigate("/main/SearchResultComponent")
    }

    return (<OutletWrapperContent>
        <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
        <Typography variant='h6' ><b>{graph.items != undefined && graph.items[0]?.Description}</b></Typography>
        <div className={localStyles.DoughnutGraphSection} onClick={sendToSearch}>
            {graph.items != undefined && graph.itemsMapproved != undefined && plugins.length > 0 ?
                <Doughnut data={doughnutData} options={opts} className={localStyles.doughnutGraph} plugins={plugins} />
                : <div>Sin datos a graficar</div>
            }
        </div>

        <Typography variant='h6'><b>{graph.items != undefined && graph.items[1]?.Description}</b></Typography>
        <div className={localStyles.barGraphSection} onClick={sendToSearch}>
            {graph.items != undefined && graph.itemsMapproved != undefined && activeData && data?.labels != undefined && data.labels != null ?
                <Bar data={data} options={options} className={localStyles.barGraph} />
                : <div>Sin datos a graficar</div>
            }
        </div>

        <Tooltip title="Nueva solicitud">
            <IconButton
                aria-label="new"
                sx={{
                    position: 'fixed',
                    bottom: '3rem',
                    right: '25vw',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                    backgroundColor: theme.palette.primary.main,
                    '&:focus': {
                        outline: 'none !important',
                    },
                    "&:hover": {
                        backgroundColor: theme.palette.primary.main80,
                    },
                    ['@media only screen and (max-width: 650px)']: {
                        bottom: '2rem',
                        right: '2vw',
                    },
                }}
                onClick={() => {
                    const nextComponent = 'SelectProductComponent'
                    coreFunctions.DoNextStage({ auth, nextComponent, navigate })
                }}>
                <AddIcon style={{
                    color: '#ffffff',
                }} />
            </IconButton>
        </Tooltip>
    </OutletWrapperContent>)
}